import { Component } from "solid-js";

const ThemeSwitcher: Component = () => {
  return (
    <label class="swap swap-rotate text-2xl">
      <input type="checkbox" class="theme-controller" value="light-dsi" />
      <i class="swap-off fa-light fa-moon" />
      <i class="swap-on fa-light fa-sun" />
    </label>
  );
};

export default ThemeSwitcher;
